import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common'

import { AccountService } from '../services';
import {Router} from "@angular/router";
import {Services} from "../models/services";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService, public datepipe: DatePipe) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {

                // this.accountService.refreshToken().subscribe((res) => {
                //     request = request.clone({
                //         setHeaders: { Authorization: `Bearer ${this.accountService.userValue.token}` }
                //     });
                //
                //     console.log('next');
                //
                //     return next.handle(request);
                // }, err => {
                //     localStorage.removeItem('user');
                //     localStorage.removeItem('role');
                //     localStorage.removeItem('permissions');
                //
                //     // auto logout if 401 response returned from api
                //     this.accountService.logout();
                //
                //     window.location.reload();
                // });

                localStorage.removeItem('user');
                localStorage.removeItem('role');
                localStorage.removeItem('permissions');
                localStorage.removeItem('lastActivityTimestamp');

                // auto logout if 401 response returned from api
                this.accountService.logout();

                window.location.reload();

            }
            // else {
                let msg = err.error.message || err.statusText;
                let messages: Array<string> = [];

                if (err.error.errors) {
                    for (let i = 0; i < err.error.errors.length; i++) {
                        messages[i] = err.error.errors[i].name + ' is reserved' + ' (' + this.datepipe.transform(err.error.errors[i].startDate, 'HH:mm', 'UTC+2') + ' to ' + this.datepipe.transform(err.error.errors[i].endDate, 'HH:mm', 'UTC+2') + ')';
                    }
                }

                const error = msg + ' ' + messages.join(', ');

                return throwError(error);
            // }
        }))
    }
}
